"use client";

/**
 * Всплывашка входящего сообщения — повторяет `chat-notification` из Nuxt
 * (components/Oqylyq/Chat/ChatComponent.vue): аватар 25px, имя, текст в одну
 * строку с многоточием. Стили лежат в globals.css под теми же классами.
 */

export type ChatToastUser = {
  firstname?: string | null;
  lastname?: string | null;
  photo?: string | null;
  color?: string | null;
};

type Props = {
  user: ChatToastUser | null;
  text: string;
  onClick?: () => void;
};

function fullName(user: ChatToastUser | null) {
  return [user?.firstname, user?.lastname].filter(Boolean).join(" ").trim();
}

function firstLetter(user: ChatToastUser | null) {
  const name = fullName(user);
  return name ? name[0].toUpperCase() : "?";
}

export function ChatMessageToast({ user, text, onClick }: Props) {
  const name = fullName(user);
  const photo = user?.photo && String(user.photo).trim() ? String(user.photo) : null;
  const background = user?.color && String(user.color).trim() ? `#${String(user.color).trim()}` : "#6B7280";

  return (
    <div className="chat-notification" onClick={onClick}>
      <div className="notification-user">
        <div className="notification-user-avatar">
          {photo ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img className="avatar-image avatar-rounded" src={photo} alt={name} />
          ) : (
            <div className="avatar-letter avatar-rounded" style={{ backgroundColor: background }}>
              <span>{firstLetter(user)}</span>
            </div>
          )}
        </div>
        <div className="notification-user-name">{name}</div>
      </div>
      <div className="notification-message">{text}</div>
    </div>
  );
}

export default ChatMessageToast;
